import isNil from "lodash/fp/isNil";
import moment from "moment";
import constants from "../../core/constants";
import { capitalize, humanize } from "../../core/utils";
class Controller {
  constructor($mdDialog, captainConflict, timezone) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.conflicts = captainConflict.conflicts;
    this.parent = captainConflict.parent;
    this.action = humanize(captainConflict.action);
    this.conflicts.forEach((conflict) => {
      conflict.type = capitalize(conflict.type);
      if (conflict.type === "Ride" || conflict.type === "Backup") {
        conflict.startTime = moment(conflict.startDate).format(
          constants.timeFormat
        );
        conflict.endTime = moment(conflict.endDate).format(
          constants.timeFormat
        );
      } else {
        conflict.startTime = moment(conflict.startTime - timezone).format(
          constants.timeFormat
        );
        conflict.endTime = moment(conflict.endTime - timezone).format(
          constants.timeFormat
        );
      }
    });
    this.parent.type = capitalize(this.parent.type);
    if (this.parent.type === "Ride" || this.parent.type === "Backup") {
      this.parent.startTime = moment(this.parent.startDate).format(
        constants.timeFormat
      );
      this.parent.endTime = moment(this.parent.endDate).format(
        constants.timeFormat
      );
    } else {
      this.parent.startTime = !isNil(this.parent.startTime)
        ? moment(this.parent.startTime - timezone).format(constants.timeFormat)
        : undefined;
      this.parent.endTime = !isNil(this.parent.endTime)
        ? moment(this.parent.endTime - timezone).format(constants.timeFormat)
        : undefined;
    }
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/conflictingDialog/conflictingDialog.controller.js